import { render } from "./AccountRegistrationRoleDetail.vue?vue&type=template&id=0455f2bc&scoped=true"
import script from "./AccountRegistrationRoleDetail.vue?vue&type=script&lang=js"
export * from "./AccountRegistrationRoleDetail.vue?vue&type=script&lang=js"

import "./AccountRegistrationRoleDetail.vue?vue&type=style&index=0&id=0455f2bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0455f2bc"]])

export default __exports__